import React, { createContext, useContext, useState } from "react";

/**
 * Lets role-specific content (rendered below AppHeader in the tree) surface a
 * DialogBubble anchored to the header's avatar button (rendered above it in
 * the tree). Mounted in DefaultAppLayout, which is the nearest common ancestor.
 */
const HeaderCalloutContext = createContext();
HeaderCalloutContext.displayName = "HeaderCalloutContext";

export const useHeaderCalloutContext = () => useContext(HeaderCalloutContext);

export const HeaderCalloutProvider = ({ children }) => {
  const [headerCallout, setHeaderCallout] = useState(null);

  return (
    <HeaderCalloutContext.Provider value={{ headerCallout, setHeaderCallout }}>
      {children}
    </HeaderCalloutContext.Provider>
  );
};

export default HeaderCalloutProvider;
